

export const dateNavBar = (user) => {

    const fecha = new Date();

    // Función para obtener el número de semana (ISO)
    function getWeekNumber(d) {
        const date = new Date(d);
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        const week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date - week1) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    }

    // Formatear número de semana con dos dígitos
    const semana = String(getWeekNumber(fecha)).padStart(2, '0');

    // Día del mes
    const diaMes = fecha.getDate();

    // 3 primeras letras del día (español)
    const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    const diaSemana = dias[fecha.getDay()];

    // 3 primeras letras del mes (español)
    const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    const mes = meses[fecha.getMonth()];

    // Obtener usuario
    const usuario = user ? (user || '').slice(0, 4) + '_' : '';

    // Resultado final
    return `${usuario}S${semana}${mes}${diaMes}${diaSemana}`;

}